import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useRequest } from "../../hooks/useRequest/useRequest";
import "./product.css";
import { IMG_URL } from "../../api/imgApi/ImgApi";

const Product = () => {
  const { t } = useTranslation();
  const lang: any = localStorage.getItem("i18nextLng");

  const [categoryClient, categoryData, categoryStatus, categoryError] =
    useRequest();

  useEffect(() => {
    categoryClient.get("category");
  }, []);

  return (
    <div className="product" id="product">
      <div
        data-aos="fade-up"
        data-aos-anchor-placement="center-bottom"
        data-aos-duration="700"
      >
        <div className="product_header">
          <h2 className={lang === "ru" ? "title active" : "title"}>
            {t("PRODUCTS.TITLEONE")}
          </h2>
          <h4 className={lang === "ru" ? "title_next active" : "title_next"}>
            {t("PRODUCTS.TITLETWO")}
          </h4>
        </div>
      </div>

      <div className="product_content">
        {categoryData?.data?.map((item: any) => (
          <div
            data-aos="zoom-in"
            data-aos-anchor-placement="top-bottom"
            data-aos-duration="600"
            key={item._id}
          >
            <div className="product_box">
              <div className="box_img">
                <LazyLoadImage
                  alt="product1"
                  effect="blur"
                  src={IMG_URL + item.imageUrl}
                  className="product_img"
                />
              </div>
              <div className="product_btn">
                <Link to={`/category/${item._id}`} className="product_link_btn">
                  <Button className="my_btn">{item.name?.[lang]}</Button>
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Product;
